<template>
  <div class="doctorIP">
    <div class="ipbox">
      <titleCard title="医生IP打造"></titleCard>
      <div class="title-text">
        通过互联网的力量为优秀的医生个人赋能，为患者创造优质的健康类内容，让医生实现更大的自我价值。
      </div>
      <div class="PC-box">
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <video
              width="100%"
              height="100%"
              controls
              ref="video"
              autoplay="autoplay"
              v-if="video1IsShow"
            >
              <source
                src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/video/5c7e628b-1811dc3f93c.mp4"
                type="video/mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/950EE6291E71498B97842E1CB6D84273-6-2.jpg" alt="" />
              <div class="btn" @click="AutoPlay(1)"></div>
            </div>
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>01</h2>
            <h3>患教科普创作</h3>
            <p>
              专业的患教科普写作团队，让枯燥、<br />深奥的医学知识变得生动、易懂
            </p>
          </div>
        </div>
        <div class="brief-box">
          <div
            class="box-txt boxstyle animate__animated wow animate__fadeInLeft"
          >
            <h2>02</h2>
            <h3>创意视频拍摄</h3>
            <p>
              健康科普类视频、音频栏目、创意策划、脚本<br />撰写、医生邀约、拍摄录制、后期特效、运营<br />发布、精准推广、数据报告
            </p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <video
              width="100%"
              height="100%"
              controls
              ref="video"
              autoplay="autoplay"
              v-if="video2IsShow"
            >
              <source
                src="https://gyycvod.yythealth.com/aa8496d771e342839c250da932fffd6c/864cb0c50b78404cb13480c747dc9471-277debec9add8b7dbf5dd9843f918ac6-ld.mp4"
                type="video/mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/AA251B0E9F82469A858F8EF44C0E02B8-6-2.png" alt="" />
              <div class="btn" @click="AutoPlay(2)"></div>
            </div>
          </div>
        </div>
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/A72D7622192D433E91BCA94399BE7E9A-6-2.png" />
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>03</h2>
            <h3>精准医学直播</h3>
            <p>线上科普讲座、学术讲座、电商<br />平台UGC直播</p>
          </div>
        </div>
        <div class="brief-box">
          <div
            class="box-txt boxstyle animate__animated wow animate__fadeInLeft"
          >
            <h2>04</h2>
            <h3>媒体矩阵营销</h3>
            <p>
              央视频、人民网、微信、微博、京东健康、今日<br />头条、百度健康、百家号、健康界、医脉通、<br />抖音发布、精准推广、数据报告
            </p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/66FB0D07E529447DB76EE7938849CE55-6-2.png" />
          </div>
        </div>
      </div>
      <div class="IOS-box">
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <video
              width="100%"
              height="100%"
              controls
              ref="video"
              autoplay
              v-if="videoIos1IsShow"
            >
              <source
                src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/video/15d2fca5-1827c5065ca.mp4"
                type="video/mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/950EE6291E71498B97842E1CB6D84273-6-2.jpg" alt="" />
              <div class="btn" @click="AutoPlay2(1)"></div>
            </div>
          </div>
          <div class="txt">
            <div class="left">
              <h2>01</h2>
            </div>
            <div class="right">
              <h3>患教科普创作</h3>
              <p>
                专业的患教科普写作团队，让枯燥、深奥的医学知识变得生动、易懂
              </p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <video
              width="100%"
              height="100%"
              controls
              ref="video"
              autoplay
              v-if="videoIos2IsShow"
            >
              <source
                src="https://gyycvod.yythealth.com/aa8496d771e342839c250da932fffd6c/864cb0c50b78404cb13480c747dc9471-277debec9add8b7dbf5dd9843f918ac6-ld.mp4"
                type="video/mp4"
              />
              <source src="movie.ogg" type="video/ogg" />
              您的浏览器不支持Video标签。
            </video>
            <div class="cover" v-else>
              <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/AA251B0E9F82469A858F8EF44C0E02B8-6-2.png" alt="" />
              <div class="btn" @click="AutoPlay2(2)"></div>
            </div>
          </div>
          <div class="txt">
            <div class="left">
              <h2>02</h2>
            </div>
            <div class="right">
              <h3>创意视频拍摄</h3>
              <p>
                健康科普类视频、音频栏目、创意策划、脚本撰写、医生邀约、拍摄录制、后期特效、运营发布、精准推广、数据报告
              </p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/A72D7622192D433E91BCA94399BE7E9A-6-2.png" />
          </div>
          <div class="txt">
            <div class="left">
              <h2>03</h2>
            </div>
            <div class="right">
              <h3>精准医学直播</h3>
              <p>线上科普讲座、学术讲座、电商平台UGC直播</p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/66FB0D07E529447DB76EE7938849CE55-6-2.png" />
          </div>
          <div class="txt">
            <div class="left">
              <h2>04</h2>
            </div>
            <div class="right">
              <h3>媒体矩阵营销</h3>
              <p>
                央视频、人民网、微信、微博、京东健康、今日头条、百度健康、百家号、健康界、医脉通、抖音发布、精准推广、数据报告
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="youzhi animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="优质案例"></titleCard>
      </div>
      <div class="youzhi-box">
        <el-carousel
          arrow="always"
          :autoplay="false"
          trigger="click"
          class="PClunbo"
        >
          <el-carousel-item v-for="(item, index) in lunboList" :key="index">
            <div class="lunbo-box">
              <div class="box-text">
                <div class="textbox">
                  <h4>{{ item.txt.name }}</h4>
                  <p v-for="(item, index) in item.txt.title" :key="index">
                    {{ item }}
                  </p>
                </div>
                <div class="textbox" style="padding-top: 0.3053rem">
                  <h4>合作项目</h4>
                  <p>医生个人号：</p>
                  <p v-for="(item, index) in item.txt.account" :key="index">
                    {{ item }}
                  </p>
                </div>
              </div>
              <div class="box-img">
                <img :src="item.pic" />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="IOSlunbo">
          <div class="swiper mySwiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in lunboList"
                :key="index"
              >
                <div class="lunbo-box">
                  <div class="box-text">
                    <div class="textbox">
                      <h4>{{ item.txt.name }}</h4>
                      <p v-for="(item, index) in item.txt.title" :key="index">
                        {{ item }}
                      </p>
                    </div>
                    <div class="textbox" style="padding-top: 0.3053rem">
                      <h4>合作项目</h4>
                      <p>医生个人号：</p>
                      <p v-for="(item, index) in item.txt.account" :key="index">
                        {{ item }}
                      </p>
                    </div>
                  </div>
                  <div class="box-img">
                    <img :src="item.pic" />
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <footerCard name="吴老师" phone="138-1097-5144"></footerCard>
  </div>
</template>

<script>
import footerCard from "../../components/footer-card.vue";
import titleCard from "../../components/title-card.vue";
import Swiper from "swiper"; // 局部引入swiper
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
export default {
  data() {
    return {
      address: "https://gyycvod.yythealth.com",
      lunboList: [
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/4183D6324F03461F9DFF84F0C8BF9C5E-6-2.png",
          txt: {
            name: "左力",
            title: [
              "北京大学人民医院肾内科主任",
              "国家卫健委能力建设和继续教育中心肾内科专委会副主委 ",
              "中国医院协会血液净化中心管理分会主任委员",
              "中国研究型医院学会血液净化专业委员会主任委员",
              "《中国血液净化》杂志副主编",
            ],
            account: [
              " 微博： 左力医生",
              "头条号： 北大人民左力",
              "健康界： 左力",
            ],
          },
        },
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/32AA49198FBE45CCAA42B1DFA8AF06DE-6-2.png",
          txt: {
            name: "隋准",
            title: [
              "北京大学人民医院内科教研室副主任",
              "获国家级专利（第一申请者）1项",
              "主持及参与国家级、省部级及院级科研项目10余项",
              "参与国际、国内多中心临床研究2项",
              "参与编写和翻译专著及教材9部",
              "在国内外专业杂志发表论文10余篇",
            ],
            account: [
              "微博： 北大人民医院_隋准",
              "头条号： 隋准",
              "抖音：  隋准",
              "百度健康： 肾内科隋准医生",
            ],
          },
        },
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D6C0A1FA515A4E2ABD911A856F45008C-6-2.png",
          txt: {
            name: "赵慧萍",
            title: [
              "北京大学人民医院肾内科主任医师",
              "北京医学奖励基金会腹膜透析专家委员会副主任委员",
              "中国研究型医院学会血液净化专业委员会常务委员",
              "北京市血液净化质控中心专家组成员",
              "北京医学会血液净化分会腹膜透析专家组医疗专家",
            ],
            account: ["微博： 赵慧萍医生", "头条号： 赵慧萍"],
          },
        },
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/7858494B5F8F4A71AA33CEB0A77AA66B-6-2.png",
          txt: {
            name: "甘良英",
            title: [
              "北京大学人民医院肾内科主任医师",
              "中国医院协会血液净化中心管理分会青年委员会组长",
              "中国医学装备协会血液净化装备技术委员会常务委员",
              "中关村血液净化诊疗技术创新联盟常务理事",
              "北京市西城区血液净化质量控制与改进中心副主任委员",
            ],
            account: ["微博： 甘良英医生", "头条号： 甘良英"],
          },
        },
      ],
      video1IsShow: false,
      video2IsShow: false,
      videoIos1IsShow: false,
      videoIos2IsShow: false,
    };
  },
  components: {
    footerCard,
    titleCard,
  },
  created() {},
  mounted() {
    new Swiper(".mySwiper", {
      spaceBetween: 30,
      pagination: ".swiper-pagination",
    });
  },
  methods: {
    AutoPlay(id) {
      if (id == 1) {
        this.video1IsShow = true;
        this.video2IsShow = false;
      } else {
        this.video2IsShow = true;
        this.video1IsShow = false;
      }
    },
    AutoPlay2(id) {
      if (id == 1) {
        this.videoIos1IsShow = true;
        this.videoIos2IsShow = false;
      } else {
        this.videoIos2IsShow = true;
        this.videoIos1IsShow = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.doctorIP {
  .ipbox {
    padding: 1.3684rem 0 1.5789rem 0;
    .title-text {
      color: #272b2d;
      font-size: 0.2526rem;
      text-align: center;
      padding: 0.5263rem 0 0;
      @media screen and (max-width: 540px) {
        padding: 30px 15px;
        font-size: 14px;
        line-height: 25px;
      }
    }
    .PC-box {
      .brief-box {
        @media screen and (max-width: 540px) {
          display: none;
        }
        padding-top: 1.0526rem;
        display: flex;
        height: 5.8421rem;
        .box-img {
          width: 50%;
          img {
            width: 100%;
            height: 100%;
          }
          .cover {
            width: 100%;
            height: 100%;
            position: relative;
            .btn {
              position: absolute;
              background: url("../../assets/image/innovatc/play.png") no-repeat;
              background-size: 100% 100%;
              width: 1.0526rem;
              height: 1.0526rem;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              cursor: pointer;
            }
          }
        }
        .boxstyle {
          padding-left: 2.5263rem !important;
        }
        .box-txt {
          width: 50%;
          box-sizing: border-box;
          padding-left: 1.5789rem;

          h2 {
            padding-top: 1rem;
            margin: 0;
            color: #0ca6eb;
            font-size: 0.8421rem;
            font-weight: 700;
            position: relative;
          }
          h2::after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: "";
            width: 0.2105rem;
            height: 0.0526rem;
            background-color: #0ca6eb;
          }
          h3 {
            margin: 0;
            padding: 0.3895rem 0 0.5053rem 0;
            color: #000000;
            font-size: 0.4211rem;
          }
          p {
            color: #333333;
            line-height: 0.4211rem;
            font-size: 0.2526rem;
          }
        }
      }
    }
    .IOS-box {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .box {
        padding: 0 15px;
        padding-top: 48px;
        .pic {
          width: 100%;
          height: 223px;
          img {
            width: 100%;
            height: 100%;
          }
          .cover {
            width: 100%;
            height: 100%;
            position: relative;
            .btn {
              position: absolute;
              background: url("../../assets/image/innovatc/play.png") no-repeat;
              background-size: 100% 100%;
              width: 50px;
              height: 50px;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              cursor: pointer;
            }
          }
        }
        .txt {
          padding-top: 15px;
          display: flex;
          .left {
            padding-right: 11px;
            h2 {
              position: relative;
              color: #0ca6eb;
              font-size: 30px;
              margin: 0;
            }
            h2::after {
              position: absolute;
              left: 9px;
              bottom: -2px;
              content: "";
              width: 18px;
              height: 3px;
              background-color: #0ca6eb;
            }
          }
          .right {
            flex-wrap: wrap;
            h3 {
              color: #000;
              font-size: 16px;
              margin: 0;
              padding-top: 8px;
              margin-bottom: 10px;
            }
            p {
              color: #333;
              font-size: 14px;
              padding-right: 15px;
            }
          }
        }
      }
    }
  }
  .youzhi {
    .title {
      margin-bottom: 1.3684rem;
      @media screen and (max-width: 540px) {
        margin-bottom: 50px;
      }
    }
    .youzhi-box {
      height: 7.0526rem;
      margin: 0 auto;
      margin-bottom: 1.7684rem;
      @media screen and (max-width: 540px) {
        height: 400px;
      }
      .PClunbo {
        @media screen and (max-width: 540px) {
          display: none;
        }
        .lunbo-box {
          padding: 0.6842rem 1.0526rem;
          display: flex;
          justify-content: space-between;
          @media screen and (max-width: 540px) {
            height: 100%;
            position: relative;
            display: block;
          }
          .box-img {
            width: 5.0105rem;
            height: 100%;
            @media screen and (max-width: 540px) {
              position: absolute;
              right: 10px;
              bottom: 40px;
              width: 152px;
              height: 150px;
            }
          }
          .box-text {
            @media screen and (max-width: 540px) {
              height: 100%;
            }
            .textbox {
              @media screen and (max-width: 540px) {
                line-height: 30px;
              }
              h4 {
                font-size: 0.2947rem;
                color: #334046;
                margin-top: 0;
                position: relative;
              }
              h4::after {
                content: "";
                position: absolute;
                bottom: -0.1105rem;
                left: 0;
                width: 0.2316rem;
                height: 0.0526rem;
                background-color: #0ca6eb;
                @media screen and (max-width: 540px) {
                  width: 10px;
                  height: 2px;
                  bottom: 0;
                  font-size: 12px;
                }
              }
              p {
                color: #6a7073;
                line-height: 0.4rem;
                font-size: 0.2211rem;
                font-weight: 300;
                @media screen and (max-width: 540px) {
                  line-height: 18px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        /deep/.el-carousel__container {
          height: 7.0526rem;
          margin: 0 auto;
          width: 12.8421rem;
          box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.04);
          margin-bottom: 1.7684rem;
          @media screen and (max-width: 540px) {
            width: 82%;
            height: 320px;
          }
          .el-carousel__arrow--right {
            right: -1.0526rem;
            @media screen and (max-width: 540px) {
              right: -35px;
            }
          }
          .el-carousel__arrow--left {
            left: -1.0526rem;
            @media screen and (max-width: 540px) {
              left: -35px;
            }
          }
        }
        /deep/ .el-carousel__arrow {
          width: 0.5263rem;
          height: 0.5263rem;
          background-color: #fff;
          border: 2px solid #c6c6c6;
          @media screen and (max-width: 540px) {
            width: 28px;
            height: 28px;
          }
          i {
            font-size: 0.2105rem;
            font-weight: 700;
          }
          color: #c6c6c6;
        }
        /deep/ .el-carousel__indicators--horizontal {
          bottom: 0.9474rem;
          @media screen and (max-width: 540px) {
            bottom: 0;
          }
        }

        /deep/ .el-carousel__button {
          height: 0.0842rem;
          background-color: #e8e8e8;
          @media screen and (max-width: 540px) {
            height: 5px;
          }
        }
        /deep/ .el-carousel__indicator.is-active button {
          background-color: #0ca6eb;
        }
        .el-carousel__item img {
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
      }
      .IOSlunbo {
        display: none;
        .swiper {
          padding-bottom: 50px;
          position: relative;
        }
        /deep/ .swiper-pagination-bullet {
          width: 11px !important;
          height: 11px !important;
        }
        .lunbo-box {
          padding: 0.6842rem 1.0526rem;
          display: flex;
          justify-content: space-between;
          @media screen and (max-width: 540px) {
            height: 100%;
            position: relative;
            display: block;
          }
          .box-img {
            width: 5.0105rem;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
            }
            @media screen and (max-width: 540px) {
              position: absolute;
              right: 10px;
              bottom: 0px;
              width: 152px;
              height: 150px;
            }
          }
          .box-text {
            @media screen and (max-width: 540px) {
              height: 100%;
            }
            .textbox {
              @media screen and (max-width: 540px) {
                line-height: 30px;
              }
              h4 {
                font-size: 0.2947rem;
                color: #334046;
                margin-top: 0;
                position: relative;
              }
              h4::after {
                content: "";
                position: absolute;
                bottom: -0.1105rem;
                left: 0;
                width: 0.2316rem;
                height: 0.0526rem;
                background-color: #0ca6eb;
                @media screen and (max-width: 540px) {
                  width: 10px;
                  height: 2px;
                  bottom: 0;
                  font-size: 12px;
                }
              }
              p {
                color: #6a7073;
                line-height: 0.4rem;
                font-size: 0.2211rem;
                font-weight: 300;
                @media screen and (max-width: 540px) {
                  line-height: 18px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        @media screen and (max-width: 540px) {
          display: block;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
